export default "__VITE_ASSET__P$ILH0qA__"